import React from "react";
import { useAppSelector } from "../redux/store";
import {
  DarkTheme as NavigationDarkTheme,
  DefaultTheme as NavigationDefaultTheme,
  NavigationContainer,
  Theme as NavigationTheme,
} from "@react-navigation/native";
import {
  adaptNavigationTheme,
  MD3DarkTheme,
  MD3LightTheme,
  PaperProvider,
} from "react-native-paper";
import merge from "deepmerge";
import { linking } from "./Linking";

const { LightTheme, DarkTheme } = adaptNavigationTheme({
  reactNavigationLight: NavigationDefaultTheme,
  reactNavigationDark: NavigationDarkTheme,
});

const CombinedDefaultTheme = {
  ...merge(MD3LightTheme, LightTheme),
  roundness: 1,
} as unknown as NavigationTheme;
const CombinedDarkTheme = merge(
  MD3DarkTheme,
  DarkTheme,
) as unknown as NavigationTheme;

export default function ThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const theme = useAppSelector((state) => state.auth.theme);

  const combinedTheme =
    theme === "dark" ? CombinedDarkTheme : CombinedDefaultTheme;

  return (
    <PaperProvider theme={combinedTheme}>
      <NavigationContainer theme={combinedTheme} linking={linking}>
        {children}
      </NavigationContainer>
    </PaperProvider>
  );
}
